import { RootState } from "integrations/redux"
import { colorFinderV2SliceName } from "./slice"

const root = (state: RootState) => state[colorFinderV2SliceName]

const selectColorFinderIsOpen = (state: RootState) => root(state).isOpen
const selectColorFinderFlightId = (state: RootState) => root(state).flightId
const selectCurrentColorFinderComment = (state: RootState) => root(state).current.commentIndex
const selectColorFinderTool = (state: RootState) => root(state).activeTool
const selectColorFinderFrameBoundingBox = (state: RootState) => root(state).frameBoundingBox
const selectColorFinderFeedFilters = (state: RootState) => root(state).feedFilters
const selectColorFinderView = (state: RootState) => root(state).view
const selectColorFinderMapSettings = (state: RootState) => root(state).mapSettings
const selectColorFinderSourceEnabled = (state: RootState) => root(state).footageOptions.source
const selectColorFinderAnomalyEnabled = (state: RootState) => root(state).footageOptions.anomaly
const selectColorFinderAnomalyOpacity = (state: RootState) =>
    root(state).footageOptions.anomalyOpacity
const selectColorFinderAnomalySensitivity = (state: RootState) =>
    root(state).footageOptions.anomalySensitivity
const selectColorFinderFootageIsZoomed = (state: RootState) => root(state).footageOptions.isZoomed
const selectColorFinderResetZoomTrigger = (state: RootState) =>
    root(state).footageOptions.resetZoomTrigger
const selectColorFinderMapIsSynced = (state: RootState) => root(state).mapSettings.synced

export {
    selectColorFinderIsOpen,
    selectColorFinderFlightId,
    selectCurrentColorFinderComment,
    selectColorFinderTool,
    selectColorFinderFrameBoundingBox,
    selectColorFinderFeedFilters,
    selectColorFinderView,
    selectColorFinderAnomalyOpacity,
    selectColorFinderAnomalySensitivity,
    selectColorFinderMapSettings,
    selectColorFinderAnomalyEnabled,
    selectColorFinderSourceEnabled,
    selectColorFinderFootageIsZoomed,
    selectColorFinderResetZoomTrigger,
    selectColorFinderMapIsSynced,
}
